import { Component, inject } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FieldMappingComponent } from '@r1-compass-library/components/form-pieces/mapper/field-mapping/field-mapping.component';
import { FieldRowComponent } from '@r1-compass-library/components/form-pieces/mapper/field-row/field-row.component';
import { FieldFillerComponent } from '@r1-compass-library/components/form-pieces/mapper/field-types/field-filler.component';
import { FieldFieldComponent } from '@r1-compass-library/components/form-pieces/mapper/field-types/field-field.component';
import { MatRadioModule } from '@angular/material/radio';
import { RowOptionChoice } from '@r1-compass-library/components';

@Component({
    selector: 'r1-compass-app-field-mapper-example',
    imports: [
        ReactiveFormsModule,
        FieldMappingComponent,
        FieldRowComponent,
        FieldFieldComponent,
        MatFormFieldModule,
        FieldFillerComponent,
        MatInputModule,
        MatRadioModule,
    ],
    template: `
        <form [formGroup]="group.at(0)">
            <r1-compass-lib-field-mapping
                [index]="0"
                [totalRequiredRows]="1"
                [rowOptionButtons]="[{ value: 'delete', display: 'DDD', show: true }]"
                (clickOption)="log($event)">
                <r1-compass-lib-field-row [fieldRowWidth]="1">
                    <r1-compass-lib-field-field [fieldWidth]="1">
                        <mat-form-field>
                            <mat-label>Type</mat-label>
                            <input matInput type="string" formControlName="valA" />
                        </mat-form-field>
                    </r1-compass-lib-field-field>
                </r1-compass-lib-field-row>
            </r1-compass-lib-field-mapping>
        </form>
        <form [formGroup]="group.at(1)">
            <r1-compass-lib-field-mapping
                [index]="1"
                [totalRequiredRows]="1"
                [rowOptionButtons]="[{ value: 'delete', display: 'DDD', show: true }]"
                (clickOption)="log($event)">
                <r1-compass-lib-field-row [fieldRowWidth]="3">
                    <r1-compass-lib-field-field [fieldWidth]="1">
                        <mat-form-field>
                            <mat-label>Type</mat-label>
                            <input matInput type="string" formControlName="valA" />
                        </mat-form-field>
                    </r1-compass-lib-field-field>
                    <r1-compass-lib-field-filler [fieldWidth]="1" />
                    <r1-compass-lib-field-field [fieldWidth]="1">
                        <mat-form-field>
                            <mat-label>Type</mat-label>
                            <input matInput type="string" formControlName="valA" />
                        </mat-form-field>
                    </r1-compass-lib-field-field>
                </r1-compass-lib-field-row>
            </r1-compass-lib-field-mapping>
        </form>
        <form [formGroup]="group.at(2)">
            <r1-compass-lib-field-mapping
                [index]="2"
                [totalRequiredRows]="1"
                [rowOptionButtons]="[{ value: 'delete', display: 'DDD', show: true }]"
                (clickOption)="log($event)">
                <r1-compass-lib-field-row [fieldRowWidth]="3">
                    <r1-compass-lib-field-field [fieldWidth]="1">
                        <mat-form-field>
                            <mat-label>Type</mat-label>
                            <input matInput type="string" formControlName="valA" />
                        </mat-form-field>
                    </r1-compass-lib-field-field>
                    <r1-compass-lib-field-field [fieldWidth]="1">
                        <mat-form-field>
                            <mat-label>Type</mat-label>
                            <input matInput type="string" formControlName="valB" />
                        </mat-form-field>
                    </r1-compass-lib-field-field>
                    <r1-compass-lib-field-field [fieldWidth]="1">
                        <mat-form-field>
                            <mat-label>Type</mat-label>
                            <input matInput type="string" formControlName="valC" />
                        </mat-form-field>
                    </r1-compass-lib-field-field>
                </r1-compass-lib-field-row>
            </r1-compass-lib-field-mapping>
        </form>
        <form [formGroup]="group.at(3)">
            <r1-compass-lib-field-mapping
                [index]="3"
                [totalRequiredRows]="1"
                [rowOptionButtons]="[
                    { value: 'delete', display: 'Delete', show: true },
                    { value: 'edit', display: 'Edit', show: true },
                ]"
                (clickOption)="log($event)">
                <r1-compass-lib-field-row [fieldRowWidth]="2">
                    <r1-compass-lib-field-field [fieldWidth]="1">
                        <mat-form-field>
                            <mat-label>Type</mat-label>
                            <input matInput type="string" formControlName="valA" />
                        </mat-form-field>
                    </r1-compass-lib-field-field>
                    <r1-compass-lib-field-field [fieldWidth]="1">
                        <mat-form-field>
                            <mat-label>Type</mat-label>
                            <input matInput type="string" formControlName="valB" />
                        </mat-form-field>
                    </r1-compass-lib-field-field>
                </r1-compass-lib-field-row>
                <r1-compass-lib-field-row [fieldRowWidth]="2">
                    <r1-compass-lib-field-field [fieldWidth]="1">
                        <mat-form-field>
                            <mat-label>Type</mat-label>
                            <input matInput type="string" formControlName="valC" />
                        </mat-form-field>
                    </r1-compass-lib-field-field>
                    <r1-compass-lib-field-field [fieldWidth]="1">
                        <mat-form-field>
                            <mat-label>Type</mat-label>
                            <input matInput type="string" formControlName="valD" />
                        </mat-form-field>
                    </r1-compass-lib-field-field>
                </r1-compass-lib-field-row>
            </r1-compass-lib-field-mapping>
        </form>
    `,
    styles: ``,
})
export class FieldMapperExampleComponent {
    readonly #fb = inject(NonNullableFormBuilder);

    group = this.#fb.array([
        this.#fb.group({
            valA: this.#fb.control('a'),
        }),
        this.#fb.group({
            valA: this.#fb.control(''),
            valB: this.#fb.control(''),
        }),
        this.#fb.group({
            valA: this.#fb.control(''),
            valB: this.#fb.control(''),
            valC: this.#fb.control(''),
        }),
        this.#fb.group({
            valA: this.#fb.control(''),
            valB: this.#fb.control(''),
            valC: this.#fb.control(''),
            valD: this.#fb.control(''),
        }),
    ]);

    log($event: RowOptionChoice) {
        console.log($event);
    }
}
